import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { _throw } from 'rxjs/observable/throw'
import { catchError, share } from 'rxjs/operators'

@Injectable()
export class HttpService {
  private options: any

  constructor(private http: HttpClient) {
    this.fillRequestOptions()
  }

  public get<T>(url: string) {
    return this.http.get<T>(url, this.options).pipe(
      share(),
      catchError((err) => this.handleError(err)))
  }

  public post<T>(url: string, body: any) {
    return this.http.post<T>(url, body, this.options).pipe(
      share(),
      catchError((err) => this.handleError(err)))

  }

  public patch<T>(url: string, body: any) {
    return this.http.patch<T>(url, body, this.options).pipe(
      share(),
      catchError((err) => this.handleError(err)))
  }

  public put<T>(url: string, body: any) {
    return this.http.put<T>(url, body, this.options).pipe(
      share(),
      catchError((err) => this.handleError(err)))
  }

  public remove<T>(url: string) {
    return this.http.delete<T>(url, this.options).pipe(
      share(),
      catchError((err) => this.handleError(err)))
  }

  private handleError(error: any) {
    return _throw(error)
  }

  private fillRequestOptions() {
    const headers = new HttpHeaders()
    headers.append('Content-Type', 'application/json')
    this.options = {headers}
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/http/http.service.ts